import { preventDefault } from "@/helpers/utils"
import { ActionsCell } from "@/molecules/ActionsCell"

import type { WarehouseReportsActionsCellComponent } from "."

export const WarehouseReportsActionsCell: WarehouseReportsActionsCellComponent =
  (props) => {
    const { noPermissions, editDisabled, t, onEdit, onDownload } = props
    const editKey = "general.edit"
    const downloadKey = "general.download"

    const getItems = (downloadDisabled: boolean) => [
      { key: downloadKey, label: t(downloadKey), disabled: downloadDisabled },
      { key: editKey, label: t(editKey), disabled: editDisabled }
    ]

    return function RecurringReportsActionsCellComponent(record) {
      return (
        <ActionsCell
          noPermissions={noPermissions}
          disabled={noPermissions}
          items={getItems(!record.pdfDownloadURL)}
          onClick={({ key, domEvent }) => {
            preventDefault(domEvent)

            if (key === editKey) onEdit(record)
            if (key === downloadKey) onDownload(record)
          }}
        />
      )
    }
  }
